// extracted by mini-css-extract-plugin
module.exports = {"container":"_1GQYMZiPIMnHKQEIaWwndh","item":"_2m-hcFjLhE6JsO0UgFAX0f","title":"_124KVO0ymsHci2LpHJYNEy","tos":"_2XRpqLrrJNnoTekFI0kxtA"};